<template>
  <div class="emblem-page">
    <section>
      <p class="title">기본형</p>
      <p class="content">
        전남드래곤즈FC 엠블럼 기본형은 클럽 정체성을 상징적/직관적으로 표현한 대표적인 시간
        언어로써 최적의 표현을 위해 일반적인 경우 단독으로 사용한다. 브랜드 시인성을 확보하기 위해
        본 항의 최소 사이즈 규정을 준수하여 오용 사례가  발생하지 않도록 유의한다.
      </p>
      <div class="logo-div">
        <div class="img-div">
          <img src="@/assets/img/club/basic_emblem_01.png" alt="basic_emblem_01">
          <img src="@/assets/img/club/basic_emblem_02.png" alt="basic_emblem_02">
        </div>
        <div class="download-div">
          <button class="ai-btn" @click="downloadFile('emblem_basic.ai')">AI 다운로드</button>
          <button class="jpg-btn" @click="downloadFile('emblem_basic.jpg')">JPG 다운로드</button>
        </div>
      </div>
    </section>
    <section>
      <p class="title">엠블럼</p>
      <p class="content">
        전남드래곤즈FC 엠블럼은 클럽 정체성을 상징적/직관적으로 표현한 대표적인 시간 언어로써
        모든 상황에서 가장 기본적으로 사용하는 로고(Club & Brand identity)이다. 브랜드 시인성을
        확보하기 위해 본 항의 최소 사이즈 규정을 준수하여 오용 사례가 발생하지 않도록 유의한다.
      </p>
      <div class="logo-div">
        <div class="img-div">
          <img src="@/assets/img/club/emblem_01.png" alt="basic_emblem_01">
          <img src="@/assets/img/club/emblem_02.png" alt="basic_emblem_02">
        </div>
        <div class="download-div">
          <button class="ai-btn" @click="downloadFile('emblem_2022.ai')">AI 다운로드</button>
          <button class="jpg-btn" @click="downloadFile('emblem_2022.jpg')">JPG 다운로드</button>
        </div>
      </div>
    </section>
    <section class="color-palette">
      <p class="title">전용 색상</p>
      <p class="content">
        전남드래곤즈FC의 전용 색상은 대내외적으로 일관된 소통을 위해 여러 요소 전반에 걸쳐
        사용함으로써 통일된 브랜드 이미지를 형성한다. 적용되는 매체의 특성 또는 기타 특수한 효과를
        얻기 위해 단도 사용이나 흑백, 금박 혹은 은색의 적용도 가능하다.
      </p>
      <div class="scroll">
        <img src="@/assets/img/club/color_palette.png" alt="color_palette">
      </div>
      <div class="download-div">
        <button class="ai-btn" @click="downloadFile('emblem_clubcolor.pdf')">PDF 다운로드</button>
      </div>
    </section>
    <section class="color-palette">
      <p class="title">배경색상 활용 규정</p>
      <p class="content">
        본 항은 배경색 명도 차이에 따라 전남드래곤즈FC 엠블럼의 사용 규정이다. 명확한 시인성을 위해
        배경색이 없는 white 배경을 기본으로 한다. 단, 불가피하게 배셩색이 있는 경우, 이미지 왜곡 및
        손상을 방지하기 위해 다음의 배경색 규정을 준수하여 오용 사례가 발생하지 않도록 한다.
      </p>
      <div class="scroll">
        <img src="@/assets/img/club/bg_color.png" alt="bg_color">
      </div>
      <div class="download-div">
        <button class="ai-btn" @click="downloadFile('emblem_background.pdf')">PDF 다운로드</button>
      </div>
    </section>
    <section class="color-palette">
      <p class="title">배경색상 활용 규정</p>
      <p class="content">
        본 항은 배경색이 전용색상일 경우의 사용 규정이다. 명확한 시인성을 위해 배경색이 없는
        white 배경을 기본으로 하며 불가피하게 배경색이 있을 경우, 이미지 왜곡 및 손상을 방지하기 위해
        다음의 배경색 사용 규정을 준수하여 오용사례가 발생하지 않도록 한다.
      </p>
      <div class="scroll">
        <img src="@/assets/img/club/bg_color_rule.png" alt="bg_color_rule">
      </div>
      <div class="download-div">
        <button class="ai-btn" @click="downloadFile('emblem_background2.pdf')">PDF 다운로드</button>
      </div>
    </section>
    <section class="color-palette">
      <p class="title">금지규정</p>
      <p class="content">
        본 항의 금지 규정을 숙지하여 전남드래곤즈FC의 엠블럼이 오용하지 않도록 각별히 유의한다.
      </p>
      <div class="scroll">
        <img src="@/assets/img/club/prohibition_rule.png" alt="prohibition_rule">
      </div>
      <div class="download-div">
        <button class="ai-btn" @click="downloadFile('emblem_incorrect.pdf')">PDF 다운로드</button>
      </div>
    </section>
  </div>
</template>

<script>
import {downloadFile} from '@/lib';

export default {
  name: 'Emblem',
  data() {
    return {
      tabList: [],
    }
  },
  mounted () {
  },
  methods: {
    downloadFile

  }
}
</script>
